import useAuthStore, {subscribeAuth} from "app/Service/Auth/AuthService"
import IsMobileService from "app/Service/Mobile/IsMobileService"
import {StoreService} from "app/Service/StoreService"
import AuthNavigationService from "app/Service/System/Auth/AuthNavigationService"
import LanguageHelmet from "app/Service/System/Language/LanguageHelmet"
import LanguageService from "app/Service/System/Language/LanguageService"
import ThemeService from "app/Service/Theme/ThemeService"
import ContentController from "app/WebController/Content/ContentController"
import HeaderController from "app/WebController/Header/HeaderController"
import TitleBar from "app/WebController/TitleBar/TitleBar"
import ToastController from "app/WebController/Toast/ToastController"
import ToolbarController from "app/WebController/Toolbar/ToolbarController"
import Logger from "logger/logger"
import React, {CSSProperties, useEffect, useMemo, useState} from "react"
import {BrowserRouter} from "react-router-dom"
import EnvironmentService from "app/Service/System/EnvironmentService"

function BootstrapWeb() {

  IsMobileService('BootstrapWeb')

  EnvironmentService([], 'BootstrapWeb')
  const {isAuthenticated} = useAuthStore([
    subscribeAuth.isAuthenticated
  ], 'BootstrapWeb')

  const {isLoadingLanguage} = LanguageService('BootstrapWeb')
  const {isLoadingTheme} = ThemeService('BootstrapWeb')

  const [booted, setBooted] = useState(false)

  useEffect(() => {
    Logger('Bootstrap.Web.init')

    return () => {
      Logger('Bootstrap.Web.unloading')
    }
  }, [])

  useEffect(function canBoot() {
    if (undefined === isAuthenticated) return
    if (undefined === isLoadingLanguage) return
    if (undefined === isLoadingTheme) return

    if (!isLoadingLanguage && !isLoadingTheme)
      setBooted(true)
  }, [isAuthenticated, isLoadingLanguage, isLoadingTheme])

  // We specifically add this div, to contain select buttons from the toolbar (E.g. when editing a layout)
  const ContentWrapperStyle: CSSProperties = {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
  }

  return useMemo(() => {
    Logger('Bootstrap.Web.booted', booted)
    if (!booted) return null
    return (
      <>
        <BrowserRouter>
          <LanguageHelmet/>
          <StoreService>
            <HeaderController/>
            {isAuthenticated && <TitleBar/>}
            <div style={ContentWrapperStyle}>
              {isAuthenticated && <ToolbarController/>}
              <ContentController/>
            </div>
            <AuthNavigationService/>
          </StoreService>
        </BrowserRouter>
        <ToastController/>
      </>
    )
  }, [booted, isAuthenticated])
}

export default BootstrapWeb
